<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App',
    mounted() {
    // if (this.$isMobile()) {
    //   this.$router.replace({
    //     path: "/m_index"
    //   });
    // }
  }
  }
</script>

<style>
  /* more */
  .building {
    height: 200px;
    line-height: 200px;
    text-align: center;
    font-size: 30px;
    color: #ccc;
  }
  .building img {
    opacity: 0.7;
    cursor: pointer;
    width: 160px;
    position: relative;
    top: 6px;
    left: 10px;
    transition: all .2s;
  }
  .building img:hover {
    opacity: 0.9;
  }
  /* 默认样式 */
  div {
    box-sizing: border-box;
  }
  #app {
    font-family: 'Microsoft YaHei', '微软雅黑', 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .w-100 {
    width: 100%;
  }
  .pos_r {
    position: relative;
  }
  .f_l {
    float: left;
  }
  .f_r {
    float: right;
  }
  .clear{
    clear: both;
  }
  .bg {
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .content {
    width: 1200px;
    margin: 0 auto;
  }
  .t-center {
    text-align: center;
  }
  .dialog .swiper-container{
    max-height: 600px;
  }
  .x-dialog .x-dialog-middle{
   background-color: rgba(255,255,255,.9) !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue